import Controller from "@ember/controller"

export default class EditPasswordController extends Controller {
  queryParams = ["resetPasswordToken", "completed", "serverError"]
  completed = false
  serverError = false
}
